<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <h3>Vision</h3>
                <p>
                    We’re building a tool to make the data analysis process simpler for
                    organizations with scarce resources. First there needs to be data 
                    collection, then curation and then analisis. Our tool uses other 
                    freemium or open source tools chosen with the principle of simplicity 
                    and accessibility first so it’s aligned with better opportunities for 
                    growing with the least effort. 
                    <br>
                    <br>

                    The data collected and presented is publicly available and belongs to 
                    the community alone. It’s used is restricted for academic and activist 
                    purposes and never for commercial or advertising. If you see a violation
                    of this rights please contact us. 
                    <br>
                    <br>
                    
                </p>
            </b-col>

            <b-col>
                
                <h3>Partners</h3>

                <p>
                    Our work it's based on the incredible effort of our partners, their researches
                    and constant work with communities and other organizations.
                </p>
                <b-container class="partners">
                    <b-row>
                        <b-col>
                            <img src="../assets/logoarticle19.png" alt="Article19 logo">
                        </b-col>

                    </b-row>
                </b-container>
            </b-col>
            

        </b-row>
    </b-container>
</template>

<script>
    export default{
        name: 'Content', 
    }
</script>

<style >
    .container-fluid{ 
        margin-top: 4em;
        padding-left:  2rem;
        padding-right:  2rem;
    }

    .partners{
        text-align: center;
    }

    .btn-primary {
        color: #fff;
        background-color: #45a158 !important ;
        border-color:#45a158 !important;
    }
    .btn{
        border-radius: 0 !important;
    }

    h2, h3, h4{
        color: #e43e74 !important;
    }

    img{
        max-width: 150px;;
    }
</style>